import { createPortalSystem } from '../portal-system/createPortalSystem';

export const floatingOverlayPortalSystem = createPortalSystem('FloatingOverlayPortal');
